import {
  AnimalIllness,
  DiagnoseVorvertrag,
  EinsatzgebieteTier,
  ExtremwetterschutzSelbstbeteiligung,
  GegenstandCategory,
  HausArt,
  KennzeichnungsArt,
  Produktlinienname,
  PrometheusCounterIncreasePayload,
  Stockwerk,
  ThhTier,
  Tierart,
  Tiergeschlecht,
  Tiergroesse,
  Tierhaltung
} from '@ps20/bff-models';
import { FEVorvertragsnummer, ValueLabelElement } from '@ps20-frontend/frontend-models';
import { AngebotsId } from './angebotsId';
import { TiergruppeAnimal } from './tiergruppeAnimal';

export enum VorschadenArt {
  FEUER = 'FEUER',
  STURM_HAGEL = 'STURM_HAGEL',
  LEITUNGSWASSER = 'LEITUNGSWASSER',
  ELEMENTAR = 'ELEMENTAR',
  OPSCHUTZ = 'OPSCHUTZ',
  VOLLSCHUTZ = 'VOLLSCHUTZ',
  NICHT_BEKANNT_SCHUTZ = 'NICHT_BEKANNT_SCHUTZ',
}

export interface VorversicherungsItemVersicherteGefahr {
  label:
    | 'Feuer'
    | 'Sturm/Hagel'
    | 'Leitungswasser'
    | 'Weitere Naturgefahren'
    | 'OP-Schutz'
    | 'Vollschutz'
    | 'Nicht bekannt';
  value: VorschadenArt;
  selected: boolean;
}

//TODO: CheckoutProdukt und Produkt im Checkout zusammen führen
export interface CheckoutProdukt extends AngebotsId {
  uebersichtTitle: string;
  produktlinie?: Produktlinienname;
  laufzeit: number;
  versichertesRisiko: string;
  geokoordinatenDetails?: string;
  vorvertragsnummer?: FEVorvertragsnummer[];
  vorvertragSofortschutz?: boolean;
  beibehalten?: boolean;
  angebotsdatum?: string;
  wirksamkeitsbeginn?: string;
  beginndatum?: string;
  shouldDisableBeginndatum?: boolean;
  isWeitererVertrag?: boolean;
  countersIncreases?: Array<PrometheusCounterIncreasePayload>;
  extremwetterschutzBeratunghinweis?: boolean;
  premiumAndExtremwetterDisabled?: boolean;
  isImmobilieImAusland?: boolean;
  beitragsfreiBeibehalten?: boolean;
  hasVorversicherung?: boolean;
  gefahrenVorversicherung?: Array<VorversicherungsItemVersicherteGefahr>;
  showEleUpload?: boolean;
}

export interface CheckoutProduktAfterLoadAzam extends AngebotsId {
  versichertesRisiko: string;
}

export interface VhvCheckoutProduktPayload extends CheckoutProdukt {
  showAngabenZumHaushalt: boolean;
  wertsachenValue: number;
  versicherungssumme: number;
  showWertsachensummeQuestion: boolean;
  staendigBewohnt: boolean;
  stockwerk: Stockwerk;
  hausart?: HausArt;
  hasWertsachen?: boolean;
  isTragerisikoSelected?: boolean;
  extremwetterschutzSelbstbeteiligung?: ExtremwetterschutzSelbstbeteiligung;
  zuersZone?: string;
  entschaedigungsbetragRad?: number;
  tragerisiko?: { entschaedigungsgrenze: number | null; einzelwert: number | null };
}

export type VhvV2CheckoutProduktPayload = VhvCheckoutProduktPayload;

export interface PhCheckoutProduktPayload extends CheckoutProdukt {
  anzahlVersicherterWohnungen: number;
}

export interface UnfCheckoutProduktPayload extends CheckoutProdukt {
  angebotsId: string; // Wahrscheinlich sollte das schon im CheckoutProdukt verpflichted gesetzt werden. Ist aber momentan optional
  unfallVp?: {
    kdvId: string;
    vorname: string;
    nachname: string;
    geburtsdatum: string;
    hasTodesfallleistung: boolean;
    hasKIS: boolean;
  };
}

export interface GegeCheckoutProduktPayload extends CheckoutProdukt {
  angebotsId: string;
  gegenstaende: {
    id: string;
    kategorie: {
      id: GegenstandCategory;
      name: string;
    };
    kaufdatum: string;
    versicherungssumme: number;
    beitrag: number;
    modell?: string;
    informationen?: string;
    anzahlVorschaeden?: number;
  }[];
  fahrradVorschaeden?: {
    provided: boolean;
    count: number;
  };
}

export interface ThhPferdProduktPayload extends CheckoutProdukt {
  anzahlPferde: number;
  tiergroesseList: Tiergroesse[];
  tiere: ThhTier[];
  tiergruppeAnimals?: TiergruppeAnimal[];
}

export interface ThhHundProduktPayload extends CheckoutProdukt {
  ausgewaehlteHunderassen: Array<string>;
  ausgewaehlteHunderassenValue: Array<string>;
  tiere: Array<ThhTier>;
  tiergruppeAnimals?: TiergruppeAnimal[];
}

export interface JagdProduktPayload extends CheckoutProdukt {
  angebotsId: string;
}

export interface TkvCheckoutProduktPayload extends CheckoutProdukt {
  tierart: Tierart;
  inBehandlung: boolean;
  rasse: ValueLabelElement;
  geburtsdatumTier: string;
  geschlecht: Tiergeschlecht;
  tierhaltung?: Tierhaltung;
  isTierKastriert?: boolean;
  tiername?: string;
  einsatzgebiet?: EinsatzgebieteTier;
  kennzeichnungsArt?: KennzeichnungsArt;
  kennzeichen?: string;
  previousDiagnoses?: DiagnoseVorvertrag[];
}

export interface TkvV2CheckoutProduktPayload extends CheckoutProdukt {
  animalType: Tierart;
  animalGender: Tiergeschlecht;
  animalName: string;
  animalBirthDate: string;
  breed: ValueLabelElement;
  catKeepingType?: Tierhaltung;
  hasIllnesses: boolean;
  selectedIllnesses?: AnimalIllness[];
  animalIdentificationType?: KennzeichnungsArt;
  animalIdentification?: string;
  previousDiagnoses?: DiagnoseVorvertrag[];
  isAssistanceDog?: boolean;
  isVnWechsel?: boolean;
}

export interface RsCheckoutProduktPayload extends CheckoutProdukt {
  hasEinFahrzeugVersichert: boolean;
  isKombischutzSelected: boolean;
  kennzeichen?: string;
}

export interface VwgCheckoutProduktPayload extends CheckoutProdukt {
  extremwetterschutzSelbstbeteiligung?: ExtremwetterschutzSelbstbeteiligung;
  zuersZone?: number;
}
